import { render, staticRenderFns } from "./RateManageModal.vue?vue&type=template&id=66cdd5e3&scoped=true&"
import script from "./RateManageModal.vue?vue&type=script&lang=js&"
export * from "./RateManageModal.vue?vue&type=script&lang=js&"
import style0 from "./RateManageModal.vue?vue&type=style&index=0&id=66cdd5e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdd5e3",
  null
  
)

export default component.exports